import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';
import { FlexButton } from '../../Button/FlexButton';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    height: 'unset',
    maxWidth: '18.75rem',
    padding: '1.5rem',
    gap: '2rem',
  },
}));

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
});

export const Box = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
});

export const CloseBox = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const CloseIconStyled = styled(CloseIcon)({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
});

export const Footer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  width: '100%',
});
